'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var tslib_es6 = require('../tslib.es6-1887e1af.js');
var launchdarklyJsClientSdk = require('launchdarkly-js-client-sdk');

var FeatureFlag = /** @class */ (function () {
    function FeatureFlag(ldClient) {
        this.ldClient = ldClient;
    }
    FeatureFlag.prototype.flag = function (key, defaultValue) {
        if (defaultValue === void 0) { defaultValue = false; }
        return this.ldClient.variation(key, defaultValue);
    };
    FeatureFlag.prototype.setUser = function (user) {
        return tslib_es6.__awaiter(this, void 0, void 0, function () {
            var error_1;
            return tslib_es6.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.ldClient.identify(user)];
                    case 1:
                        _a.sent();
                        return [3 /*break*/, 3];
                    case 2:
                        error_1 = _a.sent();
                        return [2 /*return*/, error_1];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    return FeatureFlag;
}());
var initLaunchDarklyClient = function (clientKey, user) { return tslib_es6.__awaiter(void 0, void 0, void 0, function () {
    var client, error_2;
    return tslib_es6.__generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                client = launchdarklyJsClientSdk.initialize(clientKey, user, {
                    disableSyncEventPost: true,
                });
                _a.label = 1;
            case 1:
                _a.trys.push([1, 3, , 4]);
                return [4 /*yield*/, client.waitForInitialization()];
            case 2:
                _a.sent();
                return [3 /*break*/, 4];
            case 3:
                error_2 = _a.sent();
                return [2 /*return*/, [client, error_2]];
            case 4: return [2 /*return*/, [client]];
        }
    });
}); };
var featureFlagFactory = function (clientKey, user) { return tslib_es6.__awaiter(void 0, void 0, void 0, function () {
    var _a, ldClient, error;
    return tslib_es6.__generator(this, function (_b) {
        switch (_b.label) {
            case 0: return [4 /*yield*/, initLaunchDarklyClient(clientKey, user)];
            case 1:
                _a = _b.sent(), ldClient = _a[0], error = _a[1];
                return [2 /*return*/, {
                        error: error,
                        featureFlag: new FeatureFlag(ldClient),
                    }];
        }
    });
}); };

exports["default"] = featureFlagFactory;
